const config = {
  url: '/articles',
  title: 'Статьи',
  endpoint: '/admin-search?filter=articles',
  type: 'table',
  getUrl: id => `/article/${id}`,
  getApiUrl: id => `/articles/${id}`,
  search: false,
  key: 'articles',
  access: ['*'],
  table: [
    {
      key: 'id',
      width: 75,
      title: 'ID',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.id
    },
    {
      key: 'title',
      width: 150,
      title: 'Название',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.title,
      edit: {
        component: 'Input',
        placeholder: 'Введите',
        maxLength: 255,
        required: true,
      },
    },
    {
      key: 'author',
      width: 150,
      title: 'Автор',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.author,
      edit: {
        component: 'Input',
        placeholder: 'Введите',
        maxLength: 255,
        required: false,
      },
    },
  ],
  filters: [],
}

export default config